'use client'
import { cn } from '@/utils/cn'
import React, { memo } from 'react'
// import { supportedChainId } from '@/utils/supportedChain'
// import { SwitchChainPopUp } from '../Popup/switchChainPopup'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  children?: React.ReactNode
}

/**
 *  @Base Buttton
*/

export const PrimaryButton: React.FC<ButtonProps> = memo(({
  children,
  className,
  onClick,
  ...rest
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        className
      )}
      {...rest}
    >
      {children}
    </button>
  )
})

/**
 *  @connection Butttonp
 *
*/
export default function Connect (): JSX.Element {
  return <appkit-button balance='hide' />
}
